import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const NvgtrShimmerLoader = ({ darkMode, size = 50 }) => {
  const aspectRatio = 268 / 558; // height / width from SVG viewBox
  const width = size;
  const height = Math.ceil(size * aspectRatio); // Round up to avoid cutting
  
  return (
    <div className="flex items-center justify-center">
      <SkeletonTheme 
        baseColor={darkMode ? "#2a2a2a" : "#e0e0e0"} 
        highlightColor={darkMode ? "#404040" : "#f0f0f0"}
      >
        <div 
          style={{
            width: `${width}px`,
            height: `${height}px`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <div
            style={{
              width: `${width}px`,
              height: `${height}px`,
              maskImage: `url("data:image/svg+xml,${encodeURIComponent(`
                <svg width="558" height="268" viewBox="0 0 558 268" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M253.902 0.172614C198.292 4.33261 163.672 92.9626 139.282 135.543C121.792 166.073 89.2124 227.253 47.7624 224.773C35.8124 224.063 29.0124 215.113 15.7024 216.953C7.90242 218.033 0.60242 226.653 0.0524198 234.323C-1.38758 254.593 27.1824 265.423 43.6324 266.843C140.032 275.203 184.832 128.833 228.302 66.5426C244.452 43.4026 269.312 33.7126 275.842 69.6326C285.462 122.473 268.722 229.903 331.132 256.343C375.262 275.033 412.082 232.943 434.932 201.183C442.412 190.793 466.812 157.993 469.832 148.083C474.522 132.703 464.622 118.833 448.052 122.303C439.522 124.093 432.862 132.583 427.712 138.963C408.662 162.553 351.522 268.483 329.592 186.873C319.462 149.163 323.562 106.983 318.982 68.4826C314.812 33.5626 293.822 -2.81739 253.902 0.172614Z" fill="black"/>
                  <circle cx="514.5" cy="43.5" r="43.5" fill="black"/>
                </svg>
              `)}")`,
              WebkitMaskImage: `url("data:image/svg+xml,${encodeURIComponent(`
                <svg width="558" height="268" viewBox="0 0 558 268" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M253.902 0.172614C198.292 4.33261 163.672 92.9626 139.282 135.543C121.792 166.073 89.2124 227.253 47.7624 224.773C35.8124 224.063 29.0124 215.113 15.7024 216.953C7.90242 218.033 0.60242 226.653 0.0524198 234.323C-1.38758 254.593 27.1824 265.423 43.6324 266.843C140.032 275.203 184.832 128.833 228.302 66.5426C244.452 43.4026 269.312 33.7126 275.842 69.6326C285.462 122.473 268.722 229.903 331.132 256.343C375.262 275.033 412.082 232.943 434.932 201.183C442.412 190.793 466.812 157.993 469.832 148.083C474.522 132.703 464.622 118.833 448.052 122.303C439.522 124.093 432.862 132.583 427.712 138.963C408.662 162.553 351.522 268.483 329.592 186.873C319.462 149.163 323.562 106.983 318.982 68.4826C314.812 33.5626 293.822 -2.81739 253.902 0.172614Z" fill="black"/>
                  <circle cx="514.5" cy="43.5" r="43.5" fill="black"/>
                </svg>
              `)}")`,
              maskSize: 'contain',
              WebkitMaskSize: 'contain',
              maskRepeat: 'no-repeat',
              WebkitMaskRepeat: 'no-repeat',
              maskPosition: 'center center',
              WebkitMaskPosition: 'center center'
            }}
          >
            <div style={{ width: '100%', height: '100%' }}>
              <Skeleton 
                width={width}
                height={height}
                style={{ 
                  borderRadius: 0,
                  display: 'block',
                  margin: 0,
                  padding: 0,
                  lineHeight: '1',
                  verticalAlign: 'top'
                }}
              />
            </div>
          </div>
        </div>
      </SkeletonTheme>
    </div>
  );
};

export default NvgtrShimmerLoader; 